import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  FORM,
  FORM_ACTION_TYPE,
  FORM_ALL,
  FORM_FIELD_BATCH,
  FORM_LIST,
  FORM_REQUEST,
  FORM_REQUEST_ALL,
  FORM_REQUEST_CERTIFICATE,
  FORM_REQUEST_CHANGE_STATUS,
  FORM_REQUEST_CREATE,
  FORM_REQUEST_FIELDS,
  FORM_REQUEST_ITEM,
  FORM_REQUEST_LIST,
  FORM_REQUEST_STATUS,
  FORM_TYPE,
  FORM_TYPE_ALL,
  FORM_TYPE_LIST,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const formsSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const formListSelector = createSelector(formsSelector, data => data[FORM_LIST])

export const formSelector = createSelector(formsSelector, data => data[FORM])

export const formAllSelector = createSelector(formsSelector, data => data[FORM_ALL])

export const formBatchSelector = createSelector(formsSelector, data => data[FORM_FIELD_BATCH])

export const formActionTypeSelector = createSelector(formsSelector, data => data[FORM_ACTION_TYPE])

export const formTypeSelector = createSelector(formsSelector, data => data[FORM_TYPE])

export const formTypeListSelector = createSelector(formsSelector, data => data[FORM_TYPE_LIST])

export const formTypeAllSelector = createSelector(formsSelector, data => data[FORM_TYPE_ALL])

export const formRequestSelector = createSelector(formsSelector, data => data[FORM_REQUEST])

export const formRequestItemSelector = createSelector(formsSelector, data => data[FORM_REQUEST_ITEM])

export const formRequestChangeStatusSelector = createSelector(formsSelector, data => data[FORM_REQUEST_CHANGE_STATUS])

export const formRequestCreateSelector = createSelector(formsSelector, data => data[FORM_REQUEST_CREATE])

export const formRequestListSelector = createSelector(formsSelector, data => data[FORM_REQUEST_LIST])

export const formRequestAllSelector = createSelector(formsSelector, data => data[FORM_REQUEST_ALL])

export const formRequestFieldsSelector = createSelector(formsSelector, data => data[FORM_REQUEST_FIELDS])

export const formRequestCertificateSelector = createSelector(formsSelector, data => data[FORM_REQUEST_CERTIFICATE])
